















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PicPreview from "@/components/pic-preview.vue";
import { getZhuanjia } from "@/request/idr";
import TimeTab from "./time-tab.vue";
import Jiqi from "./jiqi.vue";
import Zhuanjia from "./zhuanjia.vue";
import { GetFa, SaveFa } from "@/request/zhuanbingshujuku";
@Component({
  components: {
    PicPreview,
    TimeTab,
    Jiqi,
    Zhuanjia,
  },
})
export default class IdrToufa extends Vue {
  @Prop()
  private message: any;
  private current: any = {};
  private ifShowPicPreview: boolean = false;
  private picUrl: any = "";
  private faceIndex: any = 0;
  private cPart: any = "机器";
  private changeCurrentItem(item, index) {
    this.$set(this, "current", item);
    this.faceIndex = index;
    this.cPart = "机器";
  }
  @Watch("message", { immediate: true })
  private messageChange(msg) {
    this.partChange("机器");
  }
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }
  /**
   * @description 打开预览图
   */
  private showPreview(url) {
    this.picUrl = url;
    this.ifShowPicPreview = true;
  }
  /**
   * @description 获取数据
   */
  private partChange(part) {
    this.cPart = part;
    const params: any = {
      params: {
        patient_id: this.message["patient_id"],
        zhenci_id: this.message["zhenci_id"],
        // patient_id: "792c88fae74fbf08f091177f5262e264",
        // zhenci_id: "6113c3301c971601afdb197d",
      },
    };
    GetFa(this, params).then((data: any) => {
      this.current = data;
    });
  }
  /**
   * @description 保存数据
   */
  private save() {
    return new Promise((resolve, reject) => {
      const params = {
        hair_id: this.current.hair_id,
        信息输出: this.current["标注"],
      };
      SaveFa(this, params).then((data: any) => {
        this.partChange(this.cPart);
        // this.cContent = data;
        this.$message.success("保存成功");
        this.$store.commit("updateIfCompose", false);
        resolve();
      });
    });
  }
  /**
   * @description 刷新所有数据
   */
  private refresh() {
    this.$emit("refresh");
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (this.message && this.message.length > 0) {
      this.current = this.message[0];
    }
  }
}
